import Vue from 'vue';
import ProductsClassificationPage from './ProductsClassificationPage.vue';
import { installSharedRuntimeBridges, mountVuePage } from '@/main';
import { LazyLoader } from '@/utils/image/image-lazy-loader.utils';

type VueWithOptions = typeof Vue & {
    options?: {
        directives?: Record<string, unknown>;
    };
};

let isInstalled = false;

// 安裝 lazy-img directive，供分類頁 banner 與商品卡縮圖延遲載入使用
const installProductsClassificationLazyDirective = (): void => {
    const vueWithOptions = Vue as VueWithOptions;
    if (vueWithOptions.options?.directives?.['lazy-img']) {
        return;
    }

    const lazyLoader = new LazyLoader({
        imageCacheMode: 'rewrite',
        placeholderOptions: {
            default: {
                format: 'webp',
                quality: 80,
            },
            // banner 缺圖回退桌機預設 banner
            'product-banner-web': {
                error: '/Images/ProductsClassification/ProductBanner/default_banner_web.png',
            },
            // 商品卡縮圖限制寬度 300px
            'product-card-thumb': {
                width: 300,
            },
        },
    });
    lazyLoader.registerVueDirective('lazy-img');
};

/**
 * 安裝 product-category-products-classification 入口所需 runtime
 */
const installProductCategoryProductsClassificationRuntime = (): void => {
    if (isInstalled) return;

    installSharedRuntimeBridges();
    installProductsClassificationLazyDirective();

    isInstalled = true;
};

installProductCategoryProductsClassificationRuntime();

// SSR 命中時掛載 #ProductsClassificationPageApp 接手首屏，CSR fallback 缺 initial state 則由 client 抓取渲染
mountVuePage({
    selector: '#ProductsClassificationPageApp',
    appKey: 'product-category-products-classification-page',
    render: (h) => h(ProductsClassificationPage),
});
